import React, { useContext, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { loadTickets } from 'services/ScriptLoader';
import * as S from './styles';
import {eventIdTrackingEventGenerate} from "../../../utils/appUtils";
import {FacebookPixelContext, TiktokPixelContext} from "../../../context/tracking/declarations";
import {trackFacebookEvent, trackTiktokEvent} from "../../../context/tracking/events";
import {EventTrackingDetail} from "../../../shared/interfaces/marketing/event-tracking-detail.interface";

export type Props = {
	eventId: string,
	affiliateCode?: string | null,
	ticketToken?: string | null,
	limitedByCpf: boolean,
	hasMarketing: boolean,
	grouped: boolean,
	hasDiscount: boolean,
	meepId?: string,
}

const TicketsList = ({ eventId, affiliateCode, ticketToken, limitedByCpf, hasMarketing, grouped, hasDiscount, meepId }: Props) => {
	const { state: facebookPixelState } = useContext(FacebookPixelContext);
	const { state: tiktokPixelState } = useContext(TiktokPixelContext);
	const [ showAnchor, setShowAnchor ] = useState(false);
	const [ facebookPixelValid, setFacebookPixelValid ] = useState(false);
	const [ tiktokPixelValid, setTiktokPixelValid ] = useState(false);
	const history = useHistory();
	let ticketComponent: any;

	const handle = (comp: any) => ticketComponent = comp;

	const gotoCheckout = (ev: any) => {
		history.push({ pathname: `/inscricao/${ev.detail.reservationId}`, state: { eventId, hasMarketing } });
	}

	const reserveErrorHandler = (ev: any) => {
		toast(ev.detail.detail, { type: toast.TYPE.ERROR });
	}

	const ticketsErrorHandler = (ev: any) => {
		toast(ev.detail.detail, { type: toast.TYPE.ERROR });
	}

	useEffect(() => {
		loadTickets();
		ticketComponent.addEventListener('success', gotoCheckout);
		ticketComponent.addEventListener('get-tickets-error', ticketsErrorHandler);
		ticketComponent.addEventListener('generate-reserve-error', reserveErrorHandler);

		if (isMobile && typeof window !== 'undefined') {
			window.onscroll = () => {
				let currentScrollPos = window.pageYOffset;
				setShowAnchor(currentScrollPos > 650);
			}
		}
	}, []);

	const triggerAddTicketEvent = (ev: any) => {
		const eventData = ev.detail as EventTrackingDetail;
		if (facebookPixelState.active && facebookPixelState.eventAddToCart) {
			trackFacebookEvent('AddToCart', {
				content_name: eventData.name,
				contents: eventData,
				...(eventData.value > 0 && { value: eventData.value }),
				...(eventData.value > 0 && { currency: process.env.REACT_APP_CURRENCY })
			});
		}
		if (tiktokPixelState.active && tiktokPixelState.eventInitiateCheckout) {
			trackTiktokEvent('AddToCart',  {
				contents: [{
					content_id: eventData.id,
					content_type: "product",
					content_name: eventData.name
				}],
				...(eventData.value > 0 && { value: eventData.value }),
				...(eventData.value > 0 && { currency: process.env.REACT_APP_CURRENCY })
			});
		}
	}

	useEffect(() => {
		const shouldEnableFacebookPixel = facebookPixelState.active && !facebookPixelValid;
		const shouldEnableTiktokPixel = tiktokPixelState.active && !tiktokPixelValid;
		const shouldAttachEvents = (shouldEnableFacebookPixel || shouldEnableTiktokPixel);

		if (shouldEnableFacebookPixel) {
			setFacebookPixelValid(true);
		}
		if (shouldEnableTiktokPixel) {
			setTiktokPixelValid(true);
		}
		if (shouldAttachEvents) {
			ticketComponent.addEventListener('add-ticket', triggerAddTicketEvent);
		}

	}, [facebookPixelState, tiktokPixelValid]);

	return (
		<>
			<io-tickets
				event={eventId}
				tenant={process.env.REACT_APP_TENANT_ID}
				type="WEB"
				validate={limitedByCpf}
				color={process.env.REACT_APP_COLOR_MAIN}
				affiliate={affiliateCode}
				token={ticketToken}
				grouped={grouped}
				discount={hasDiscount}
				meepid={meepId || null}
				ref={handle}
			/>
			<S.TicketsBoxAnchor style={{bottom: (showAnchor ? 0 : '-60px')}} to="boxTop" offset={-40} smooth={true}>Ver Ingressos</S.TicketsBoxAnchor>
		</>
	)
}

export default TicketsList;
